/**
 * Select2 handler for Color or Image Variation Swatches for WooCommerce Pro.
 *
 * @version   1.2.3
 * @since     1.0.0
 * @requires  jQuery.js
 */

/**
 * Sets up Select2 for the variation selects.
 *
 * @since   1.2.3
 * @version 1.2.3
 *
 * @param {Object} alg_wc_civs The free version swatches object.
 */
export default function select2Handler( alg_wc_civs ) {
	var $ = jQuery;

	var alg_wc_civs_select2 = {
		term_selector: null,
		original_select_selector: null,

		/**
		 * Initiate.
		 */
		init: function () {            
			var term_str = this.term_selector;
			var select_str = this.original_select_selector;
			$(select_str).select2({
				templateResult: formatState,
				templateSelection: formatState,
				width: '100%'
			});

			function formatState(state) {
				if (!state.id) {
					return state.text;
				}
				var term = $(term_str + '[data-value="' + state.id + '"]').prop('outerHTML');

				var $state = $(
					'<span class="alg-wc-civs-select2-img-wrapper">' + term + '</span>' + '<span class="alg-wc-civs-select2-label">' + state.text + '</span>'
				);
				return $state;
			}
		}
	};

	window.alg_wc_civs_select2 = alg_wc_civs_select2;
	alg_wc_civs_select2.term_selector = alg_wc_civs.term_selector;
	alg_wc_civs_select2.original_select_selector = alg_wc_civs.original_select_selector;
	alg_wc_civs_select2.init();
}